import { useState, useEffect } from 'react';
import {
  Button,
  Col,
  Form,
  Row,
  Select,
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import qs from 'query-string';
import './index.less';
import { getIndustryChain, getProjectName } from '@/services/supplyChainFinance';

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const titleMap = {
  1: '链主企业申报',
  2: '链属企业申报',
  3: '相关经营主体申报',
};

export default function ProjectSelect() {
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const { search } = useLocation();
  const { type } = qs.parse(search);
  const [canSubmit, setCanSubmit] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [selectedIndustryChain, setSelectedIndustryChain] = useState(undefined);

  const { data: industryChainData = [] } = useRequest(getIndustryChain);

  const { data: projectNameData = [] } = useRequest(getProjectName);

  // 将getIndustryChain返回的字符串数组转换为Select选项格式
  const industryChainOptions = industryChainData.map((chain) => ({
    label: chain,
    value: chain,
  }));

  // 监听表单值变化
  const handleFormChange = () => {
    const values = form.getFieldsValue();
    const isComplete = values.reserveProjectCode && values.billionAgriProjectId;
    setCanSubmit(isComplete);
  };

  // 当选择产业链时，筛选项目名称列表
  const handleReserveProjectChange = (selectedChain) => {
    // 清空项目名称选择
    form.setFieldsValue({ billionAgriProjectId: undefined });
    setCanSubmit(false);
    setSelectedIndustryChain(selectedChain);

    // 根据选中的产业链筛选项目数据，组合projectName和billionAgriProjectId
    if (selectedChain && projectNameData && projectNameData.length > 0) {
      const filteredProjects = projectNameData
        .filter((item) => item.industryChain === selectedChain)
        .map((item) => ({
          label: item.projectName,
          value: item.billionAgriProjectId,
        }));
      setProjectList(filteredProjects);
    } else {
      setProjectList([]);
    }
  };

  const handlePrevious = () => {
    Navigate('/supplyChain/home');
  };

  const handleNext = () => {
    // TODO: 需要增加判断用户是否填报过对应类型的产业链项目
    const values = form.getFieldsValue();
    const params = {
      type,
      billionAgriProjectId: values.billionAgriProjectId,
    };
    Navigate(`/supplyChain/application?${qs.stringify(params)}`);
  };

  useEffect(() => {
    if (!type) {
      Navigate('/supplyChain/home');
    }
  }, [type, Navigate]);

  return (
    <div className="supply-chain-finance__project">
      <div className="supply-chain-finance__banner">
        产业链金融
      </div>
      <div className="content-width">
        <div className="supply-chain-finance__info-title">{titleMap[type]}</div>
        <div className="margin-top20">
          <Form
            {...formItemLayout}
            form={form}
            name="form"
            className="form"
            onValuesChange={handleFormChange}
          >
            <Row>
              <Col span={10}>
                <Form.Item
                  name="reserveProjectCode"
                  label="所属产业链"
                  rules={[
                    {
                      required: true,
                      message: '请选择所属产业链',
                    },
                  ]}
                >
                  <Select
                    placeholder="请选择所属产业链"
                    options={industryChainOptions}
                    onChange={handleReserveProjectChange}
                  />
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item
                  name="billionAgriProjectId"
                  label="项目名称"
                  rules={[
                    {
                      required: true,
                      message: '请选择项目名称',
                    },
                  ]}
                >
                  <Select
                    placeholder="请选择项目名称"
                    options={projectList}
                    disabled={!selectedIndustryChain}
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row gutter={24} className="button-row">
            <Col span={8} />
            <Col span={4}>
              <Button type="primary" onClick={handlePrevious} block>
                上一步
              </Button>
            </Col>
            <Col span={4}>
              <Button type="primary" onClick={handleNext} disabled={!canSubmit} block>
                下一步
              </Button>
            </Col>
            <Col span={8} />
          </Row>
        </div>
      </div>
    </div>
  );
}
